<div class="Flexbox Flexbox_rows Flexbox__just-space-around Flexbox__box-align-center">
    <div>
        <div class="ff_CentraleSansBook fs7">
            {{test.disease}} ({{test.revision}})
        </div>
        <div class="ff_CentralSansLight fs9">
            Last update: {{test.date | date: 'dd MMM yyyy'}}
        </div>
    </div>

    <div class="align-right ff_CentraleSansBold fs7">{{test.status}}</div>
</div>
